var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Swap"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Swap_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.35612 10.1583C3.35612 10.465 3.60222 10.7139 3.90545 10.7139C4.20867 10.7139 4.45477 10.465 4.45477 10.1583V2.42497L6.20456 4.2016C6.41843 4.41942 6.76561 4.41942 6.98094 4.20308C7.19628 3.98674 7.19701 3.63483 6.98241 3.41701L4.29437 0.686872C4.13763 0.526843 3.90032 0.480167 3.69597 0.565368C3.49016 0.65131 3.35612 0.85357 3.35612 1.0788V10.1583ZM1.21739 4.36504C1.07749 4.36504 0.936865 4.31095 0.82993 4.20278C0.614594 3.98645 0.613861 3.63527 0.828465 3.41745L1.89782 2.33058C2.11242 2.11277 2.4596 2.11277 2.67493 2.3291C2.88954 2.54544 2.89027 2.89736 2.6764 3.11517L1.60631 4.2013C1.49938 4.31095 1.35802 4.36504 1.21739 4.36504ZM10.2409 12.4812C10.3083 12.5093 10.3793 12.5234 10.4504 12.5234C10.5939 12.5234 10.7346 12.4671 10.8393 12.3597L13.1399 10.0222C13.3537 9.80437 13.353 9.45245 13.1384 9.23611C12.9231 9.01978 12.5752 9.02052 12.3613 9.23759L10.9997 10.6223V2.88753C10.9997 2.5808 10.7543 2.33187 10.4504 2.33187C10.1471 2.33187 9.90104 2.5808 9.90104 2.88753V11.9677C9.90104 12.193 10.0351 12.3952 10.2409 12.4812ZM8.44145 10.7151C8.54912 10.8247 8.69048 10.8788 8.83111 10.8788C8.971 10.8788 9.11163 10.8247 9.21856 10.7166C9.4339 10.5002 9.43463 10.1491 9.22076 9.93124L8.15141 8.84438C7.93607 8.62656 7.5889 8.62656 7.37429 8.84289C7.15896 9.05923 7.15822 9.41115 7.3721 9.62897L8.44145 10.7151Z",
    fill: "#F7F7F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapBtnIcon);
export default __webpack_public_path__ + "static/media/swap_btn_icon.158b01973e0627b766c422db21f27c3a.svg";
export { ForwardRef as ReactComponent };